































































































































































import Vue from "vue";
import store, { LoginStore } from "../services/LoginStore";
import auth, { Authentication } from "../../../services/auth";
import http, { setConnection } from "../../../services/http";
import { set } from "vue/types/umd";
import ApiResponse from "@/models/ApiResponse";
import LoginResult from "../models/LoginResult";
import eventBus from "@/services/eventBus";
import { getLanguage, setLanguage, Language, LANGUAGE_NAMES, SUPPORTED_LANGUAGES } from "@/plugins/i18n";

interface ConnectionList {
  useDealerCode: boolean;
  connections: ConnectionItem[];
}

interface ConnectionItem {
  key: string;
  dealerCode: string;
}

interface Data {
  store: LoginStore;
  useDealerCode: boolean;
  connections: ConnectionItem[];
  filteredConnections: ConnectionItem[];
  selectedConnection: ConnectionItem;
  auth: Authentication;
  dealerCodeNotSelected: boolean;
  hasUser2FAValidation: boolean;
  uncorrectVerificationCode: boolean;
  preAuthToken: string;
  languages: { code: Language; name: string }[];
  language: Language;
}

interface Methods {
  changeLanguage(language: Language): void;
  loadConnections(): Promise<void>;
  login(): void;
  dealerCodeChangedHandler(): void;
  setTokenAndRedirect(): void;
  authenticateUser(): void;
}

const LAST_CONNECTION_ID_KEY = "trufinance.lastConnectionID";
const LAST_CONNECTION_DEALERCODE = "trufinance.lastConnectionDealerCode";

export default Vue.extend<Data, Methods, {}, {}>({
  components: {},

  data(): Data {
    return {
      store,
      useDealerCode: false,
      connections: [],
      filteredConnections: [],
      auth,
      selectedConnection: { key: "", dealerCode: ""},
      dealerCodeNotSelected: false,
      hasUser2FAValidation: false,
      uncorrectVerificationCode: false,
      preAuthToken: '',
      languages: SUPPORTED_LANGUAGES.map((code) => ({ code, name: LANGUAGE_NAMES[code] })),
      language: getLanguage(),
    };
  },

  beforeMount() {
    this.loadConnections();
    if (auth.isLoggedIn) this.$router.push("/");
  },

  methods: {
    changeLanguage(language: Language) {
      // A login oldal feliratai ($t) azonnal váltanak; a Vuetify és a Kendo feliratok a nyelvet a plugin állapotából követik
      setLanguage(language);
      this.$vuetify.lang.current = language;
    },

    dealerCodeChangedHandler() {
      if (this.useDealerCode) {
        this.selectedConnection = { key: "", dealerCode: ""};
        if (!this.store.login.code) {
          this.filteredConnections = [];
        }
        else {
          this.filteredConnections = [...this.connections.filter((x => x.dealerCode.toUpperCase() === this.store.login.code.toUpperCase()))];
          this.dealerCodeNotSelected = false;
        }
      }
    },

    async loadConnections() {
      const response = await http.get<ConnectionList>(`connections`);
      if (response.data) {
        this.useDealerCode = response.data.useDealerCode;
        this.connections = response.data.connections;

        if (!this.useDealerCode) {
          this.filteredConnections = [...this.connections];
        }
      }

      const lastConnectionID = window.localStorage.getItem(LAST_CONNECTION_ID_KEY);
      const lastConnectionDealerCode = window.localStorage.getItem(LAST_CONNECTION_DEALERCODE);

      if (lastConnectionID && this.connections.map(x => x.key).includes(lastConnectionID)) {
        this.selectedConnection.key = lastConnectionID;

        if (this.useDealerCode) {
          this.selectedConnection.dealerCode = lastConnectionDealerCode ?? "";
        }
      }
    },

    login() {
      if (this.useDealerCode && !this.store.login.code) {
        this.dealerCodeNotSelected = true;
        return;
      }


      this.store.doLogin().then(async () => {
        if (this.store.loginResult.success) {
          // A backend kétfaktoros felhasználónak nem ad hozzáférési tokent, csak elő-tokent:
          // a végleges tokent a login/two-factor végpont adja a sikeres kód után.
          if (this.store.loginResult.requiresTwoFactor) {
            this.preAuthToken = this.store.loginResult.preAuthToken ?? '';
            this.uncorrectVerificationCode = false;
            this.hasUser2FAValidation = true;
          } else {
            this.setTokenAndRedirect();
          }
        }
      });
    },
    async setTokenAndRedirect(){
        await auth.setToken(
            this.store.loginResult.token,
            this.store.loginResult.userName,
            this.store.loginResult.userID
          );

          const redirect = this.$route.query.redirect || "/";
          this.$router.push(`${redirect}`);
          this.dealerCodeNotSelected = false;
    },
    authenticateUser(){
      http.post<ApiResponse<LoginResult>>('login/two-factor', {
        preAuthToken: this.preAuthToken,
        code: this.store.login.verificationCode
      }).then(response => {
        const result = response.data?.data;
        if (result && result.success && result.token) {
          this.store.loginResult = result;
          this.store.login.verificationCode = '';
          this.uncorrectVerificationCode = false;
          this.setTokenAndRedirect();
        }
        else {
          this.uncorrectVerificationCode = true;
          if (result?.message) {
            eventBus.$emit("error", result.message);
          }
        }
      });
    }

  },

  watch: {
    selectedConnection(conn: ConnectionItem) {
      setConnection(conn.key);
      window.localStorage.setItem(LAST_CONNECTION_ID_KEY, conn.key);
      if (this.useDealerCode) {
        window.localStorage.setItem(LAST_CONNECTION_DEALERCODE, conn.dealerCode);
      }
      else {
        window.localStorage.setItem(LAST_CONNECTION_DEALERCODE, "");
      }
    },
  },
});
